import React from "react";
import { Link } from "react-router-dom";
import { Sparkles, ArrowLeft } from "lucide-react";
import PublicShell from "../components/PublicShell";

const About = () => (
  <PublicShell>
    <section className="max-w-3xl mx-auto px-4 py-16 md:py-24" data-testid="about-page">
      <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-white border border-[#7AB2B2] text-xs font-bold text-[#09637E] mb-5">
        <Sparkles size={14} /> عن المنصة
      </div>
      <h1 className="text-4xl md:text-5xl font-extrabold text-[#333333] mb-6">من نحن</h1>
      <div className="bg-white border border-[#7AB2B2] rounded-2xl p-8 leading-relaxed text-lg text-[#333333]">
        <p>
          منصة <span className="font-extrabold text-[#09637E]">إمداد</span> هي أول منصة في سوريا تربط تجار السيراميك
          ومواد البناء ببعضهم البعض. نهدف إلى حل مشكلة نقص البضائع وضعف رأس المال لدى التجار من خلال ربط المخازن
          ببعضها. نتيح للتجار البحث عن أي صنف غير متوفر لديهم والحصول عليه من تجار آخرين بكل سهولة وخصوصية تامة.
        </p>
      </div>
      <Link to="/register" data-testid="about-register"
        className="mt-8 inline-flex items-center gap-2 h-12 px-6 rounded-lg bg-[#09637E] hover:bg-[#088395] text-white font-extrabold">
        سجّل كتاجر <ArrowLeft size={18} />
      </Link>
    </section>
  </PublicShell>
);

export default About;
